import jsonApi from '../../utils/jsonApi'
import http from '../../utils/http'

export const getPAChild = ({ page, params }) => {
  return jsonApi
    .findAll('pickup_authorization_children', {
      params: {
        'q[s]': 'created_at desc',
        'page[number]': page || 1,
        ...params
      }
    })
    .then(res => res)
}

export const createPickupAuthorizationChildren = params => {
  return http.post('pickup_authorization_children', {
    data: {
      type: 'pickup_authorization_children',
      attributes: {
        ...params
      }
    }
  })
}

export const deletePickupAuthorizationChildren = id => {
  return http.delete(`pickup_authorization_children/${id}`)
}
